"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

require("../styles/_asset-quantity-warning-modal.scss");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function AssetQuantityWarningModal(_ref) {
  var onClose = _ref.onClose,
      visible = _ref.visible,
      onContinue = _ref.onContinue;
  return (/*#__PURE__*/_react.default.createElement("div", {
      className: "asset-quantity-warning-modal"
    }, /*#__PURE__*/_react.default.createElement(_uiKit.FormModal, {
      visible: visible,
      title: "Are you sure?",
      onClose: onClose,
      saveText: "CANCEL"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "asset-quantity-warning-modal__content"
    }, /*#__PURE__*/_react.default.createElement("p", null, 'You\'re about to use more than the recommended number of clips for your video. ', /*#__PURE__*/_react.default.createElement("strong", null, "We recommend using less than 50 assets in a single video.")), /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
      small: true,
      onClick: onContinue
    }, 'YES I\'M SURE'))))
  );
}

var _default = (0, _react.memo)(AssetQuantityWarningModal);

exports.default = _default;